import React from 'react'
import { useRoute } from '@react-navigation/core'
import { RouteProp } from '@react-navigation/native'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { Text } from '@components/base'
import { BottomSheet, OutlinedIcon } from '@components'
import { StyleService, useStyleSheet } from '@style/service.ts'
import { DAY_NAME_MONTH_AND_DATE_WITH_YEAR_FORMAT } from '@config/momentFormat.ts'
import { AppStackParamList } from '@navigation/types'
import { uhcDeepLinkSelector } from '@selectors/app.ts'
import { openUrl } from '@utils'

export const NoMoreCallsLeftModal = () => {
  const styles = useStyleSheet(themedStyles)
  const route = useRoute<RouteProp<AppStackParamList, 'NoMoreCallsLeftModal'>>()
  const uhcDeepLinks = useSelector(uhcDeepLinkSelector)
  const { nextBillingDate, recurring } = route.params

  const onPress = () => {
    openUrl(uhcDeepLinks.storeUrl)
  }

  return (
    <BottomSheet style={styles.container} primaryButton={{ text: 'Go to the UHC Store', onPress }}>
      {!recurring ? (
        <>
          <OutlinedIcon iconName="calendar-blank" style={styles.icon} />
          <Text type="title-3" style={styles.text}>
            Nice Work! You've completed all of your coaching calls this month
          </Text>
          <Text type="regular" style={[styles.text, { marginBottom: 24 }]}>
            More calls will unlock when your subscription renews on{' '}
            {moment(nextBillingDate).format(DAY_NAME_MONTH_AND_DATE_WITH_YEAR_FORMAT)}.
          </Text>
          <Text type="regular" style={styles.text}>
            <Text type="regular" bold>
              Need more before then?{'\n'}
            </Text>
            You can purchase an extra month of coaching in the UHC Store (as a one-time add-on).
            We’ll add two more calls to your current credits right away.
          </Text>
        </>
      ) : (
        <>
          <OutlinedIcon iconName="warning" style={styles.icon} />
          <Text type="title-3" style={styles.text}>
            Nice Work! You've completed all of your coaching calls this month
          </Text>
          <Text type="regular" style={styles.text}>
            To get more, you need to renew your subscription in the UHC Store.
          </Text>
        </>
      )}
    </BottomSheet>
  )
}

const themedStyles = StyleService.create({
  container: {
    paddingHorizontal: 24,
  },
  text: {
    marginBottom: 24,
    textAlign: 'center',
  },
  icon: {
    alignSelf: 'center',
  },
})
